import { render, staticRenderFns } from "./SiteSwitcher.vue?vue&type=template&id=771a9fe1&"
import script from "./SiteSwitcher.vue?vue&type=script&lang=js&"
export * from "./SiteSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports